import { Box, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import { PmStats } from "../../data/models/stats";
import { useTranslation } from "react-i18next";

interface DeactiavtedPMsTableProps {
    data: PmStats[];
    title?: string;
}

function DeactivatedPMsStatsTable({ data, title }: DeactiavtedPMsTableProps) {
    const { t } = useTranslation();
    return (
        <TableContainer component={Paper} sx={{ bgcolor: "#fff" }}>
            {title && <Box sx={{ p: 1 }}>
                <Typography component={"h2"} variant="h6">{title}</Typography>
            </Box>}
            <Table sx={{ minWidth: 650 }} aria-label="caption table">
                <TableHead>
                    <TableRow>
                        {data.map((row) =>
                            <TableCell key={row.type} sx={{ textAlign: "center" }}>{row.type}</TableCell>
                        )}
                        <TableCell sx={{ textAlign: "center" }}>{t("CARD_TOTAL")}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        {data.map((row) =>
                            <TableCell key={row.type} sx={{ textAlign: "center" }}>{row.total}</TableCell>
                        )}
                        <TableCell sx={{ textAlign: "center", bgcolor: "#ffc10726", fontWeight: 600 }}>
                            {data.reduce((acc, result) => {
                                return acc + result.total;
                            }, 0)}
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>
    );
}

export default DeactivatedPMsStatsTable;